export default "__VITE_ASSET__KmTUPq$c__"